/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { withStyles, Grid, Typography, Button } from '@material-ui/core';

const styles = theme => ({
  footer: {
    backgroundColor: theme.palette.grey[100],
    paddingBottom: '110px'
  },
  img: {
    paddingRight: '100px'
  },
  socialtxt: {
    marginLeft: '20px',
    textTransform: 'none'
  }
});

const Footer = class extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <section className={classes.footer}>
        <div className="wrapper">
          <Typography
            paragraph
            align="center"
            color="primary"
            variant="h2"
            style={{ fontSize: 50 }}
          >
            Follow us!
          </Typography>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                variant="text"
                href="https://fb.me/u2iSoftWar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="16"
                  src="/images/social/fb.png"
                  alt="Facebook Icon"
                />
                <Typography variant="subtitle2" className={classes.socialtxt}>
                  fb.me/u2iSoftWar
                </Typography>
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Button
                variant="text"
                href="https://instagram.com/u2isoftwar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img height="16" src="/images/social/ig.png" alt="Insta Icon" />
                <Typography variant="subtitle2" className={classes.socialtxt}>
                  instagram.com/u2isoftwar
                </Typography>
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Button
                variant="text"
                href="https://twitter.com/u2isoftwar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="16"
                  src="/images/social/tw.png"
                  alt="Twitter Icon"
                />
                <Typography variant="subtitle2" className={classes.socialtxt}>
                  twitter.com/u2iSoftWar
                </Typography>
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Button
                variant="text"
                href="http://www.u2i.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                <img height="16" src="/images/social/u2i.png" alt="u2i Icon" />
                <Typography variant="subtitle2" className={classes.socialtxt}>
                  u2i.com
                </Typography>
              </Button>
            </Grid>
          </Grid>
          <div style={{ textAlign: 'center', margin: '20px auto 20px' }}>
            <Typography paragraph inline align="center" variant="body1">
              You can also contact us via email:{' '}
            </Typography>
            <Typography inline paragraph align="center" variant="body2">
              softwar@u2i.com
            </Typography>
          </div>
          <div style={{ textAlign: 'center', margin: '20px auto 20px' }}>
            <Typography paragraph inline align="center" variant="body1">
              <a
                href="https://drive.google.com/open?id=1zSZHsA-pm4o0HlaiDBCqXgXTkzvEGe_0"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#3c913e' }}
              >
                Press pack
              </a>
            </Typography>
            &nbsp; &nbsp; &nbsp;
            <Typography paragraph inline align="center" variant="body1">
              <a
                href="https://drive.google.com/open?id=1ToHFi4NKJRMwO2VDjhp0R8KmcuLA68xuanJcTlHlhlA"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#3c913e' }}
              >
                Privacy Policy
              </a>
            </Typography>
          </div>
          <Typography paragraph gutterBottom align="center" variant="body1">
            2019 &copy; u2i.com
          </Typography>
        </div>
      </section>
    );
  }
};

export default withStyles(styles)(Footer);
